export enum Language {
  RO = 'RO',
  EN = 'EN',
}
